export const AtlassianDataLakeLogoInverse = () => (
  <svg
    width="501"
    height="48"
    viewBox="0 0 501 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2189_2933)">
      <path
        d="M106.72 18.3599C106.72 22.5599 108.67 25.8999 116.29 27.3699C120.84 28.3199 121.79 29.0599 121.79 30.5699C121.79 32.0799 120.84 32.9999 117.63 32.9999C113.91 32.9999 109.49 31.7399 106.59 30.0099V36.8499C108.89 37.9799 111.92 39.2299 117.55 39.2299C125.52 39.2299 128.68 35.6799 128.68 30.3899M128.68 30.3899C128.68 25.4099 126.04 23.0699 118.59 21.4699C114.48 20.5599 113.48 19.6499 113.48 18.3499C113.48 16.6999 114.95 16.0099 117.68 16.0099C120.97 16.0099 124.22 17.0099 127.29 18.3899V11.8499C125.12 10.7699 121.79 9.8999 117.89 9.8999C110.53 9.8999 106.72 13.0999 106.72 18.3499"
        fill="white"
      />
      <path
        d="M209.1 10.3501V38.8001H215.16V17.1001L217.72 22.8601L226.29 38.8001H233.92V10.3501H227.85V28.7101L225.56 23.3801L218.67 10.3501H209.1Z"
        fill="white"
      />
      <path d="M170.54 10.3501H163.91V38.8001H170.54V10.3501Z" fill="white" />
      <path
        d="M156.26 30.3997C156.26 25.4197 153.62 23.0797 146.17 21.4797C142.06 20.5697 141.06 19.6597 141.06 18.3597C141.06 16.7097 142.53 16.0197 145.26 16.0197C148.55 16.0197 151.8 17.0197 154.87 18.3997V11.8597C152.7 10.7797 149.37 9.90967 145.47 9.90967C138.11 9.90967 134.3 13.1097 134.3 18.3597C134.3 22.5597 136.25 25.8997 143.87 27.3697C148.42 28.3197 149.37 29.0597 149.37 30.5697C149.37 32.0797 148.42 32.9997 145.21 32.9997C141.49 32.9997 137.07 31.7397 134.17 30.0097V36.8497C136.47 37.9797 139.5 39.2297 145.13 39.2297C153.1 39.2297 156.26 35.6797 156.26 30.3897"
        fill="white"
      />
      <path
        d="M55.24 10.3501V38.8001H68.86L71.01 32.6501H61.91V10.3501H55.24Z"
        fill="white"
      />
      <path
        d="M28.33 10.3501V16.5001H35.7V38.8001H42.37V16.5001H50.25V10.3501H28.33Z"
        fill="white"
      />
      <path
        d="M18.66 10.3501H9.92L0 38.8001H7.58L8.99 34.0101C10.67 34.5001 12.45 34.7701 14.3 34.7701C16.15 34.7701 17.92 34.5001 19.61 34.0101L21.02 38.8001H28.6L18.66 10.3501ZM14.29 28.8801C13.02 28.8801 11.8 28.6901 10.64 28.3601L14.29 15.9401L17.94 28.3601C16.78 28.7001 15.56 28.8801 14.29 28.8801Z"
        fill="white"
      />
      <path
        d="M92.34 10.3501H83.6L73.68 38.8001H81.26L82.67 34.0101C84.35 34.5001 86.13 34.7701 87.98 34.7701C89.83 34.7701 91.6 34.5001 93.29 34.0101L94.7 38.8001H102.28L92.36 10.3501H92.34ZM87.97 28.8801C86.7 28.8801 85.48 28.6901 84.32 28.3601L87.97 15.9401L91.62 28.3601C90.46 28.7001 89.24 28.8801 87.97 28.8801Z"
        fill="white"
      />
      <path
        d="M194.41 10.3501H185.67L175.75 38.8001H183.33L184.74 34.0101C186.42 34.5001 188.2 34.7701 190.05 34.7701C191.9 34.7701 193.67 34.5001 195.36 34.0101L196.77 38.8001H204.35L194.43 10.3501H194.41ZM190.04 28.8801C188.77 28.8801 187.55 28.6901 186.39 28.3601L190.04 15.9401L193.69 28.3601C192.53 28.7001 191.31 28.8801 190.04 28.8801Z"
        fill="white"
      />
      <path
        d="M252.15 8.56982H263.28C273.08 8.56982 277.82 14.6898 277.82 23.7498C277.82 32.8098 273.04 38.7898 263.28 38.7898H252.15V8.56982ZM256.29 12.5298V34.8398H263.33C270.23 34.8398 273.68 31.2098 273.68 23.8898C273.68 16.5698 270.41 12.5298 263.1 12.5298H256.29Z"
        fill="white"
      />
      <path
        d="M298.25 34.6598C296.78 37.6998 294.02 39.2598 290.48 39.2598C284.36 39.2598 281.28 34.0598 281.28 27.2998C281.28 20.5398 284.5 15.3398 290.94 15.3398C294.3 15.3398 296.87 16.8598 298.25 19.8498V15.7998H302.21V38.7998H298.25V34.6598ZM291.53 35.5798C295.07 35.5798 298.25 33.3298 298.25 28.2198V26.3798C298.25 21.2698 295.35 19.0198 291.99 19.0198C287.53 19.0198 285.23 21.9598 285.23 27.2998C285.23 32.6398 287.44 35.5798 291.53 35.5798Z"
        fill="white"
      />
      <path
        d="M317.29 35.0699C318.21 35.0699 319.08 34.8899 319.77 34.7499V38.5699C319.08 38.7499 318.3 38.9399 317.1 38.9399C312.18 38.9399 309.79 36.0399 309.79 31.7599V19.4799H306.06V15.7999H309.79V10.9199H313.65V15.7999H319.77V19.4799H313.65V31.6699C313.65 33.6899 314.85 35.0699 317.28 35.0699H317.29Z"
        fill="white"
      />
      <path
        d="M339.51 34.6598C338.04 37.6998 335.28 39.2598 331.73 39.2598C325.61 39.2598 322.53 34.0598 322.53 27.2998C322.53 20.5398 325.75 15.3398 332.19 15.3398C335.55 15.3398 338.12 16.8598 339.5 19.8498V15.7998H343.46V38.7998H339.5V34.6598H339.51ZM332.79 35.5798C336.33 35.5798 339.51 33.3298 339.51 28.2198V26.3798C339.51 21.2698 336.61 19.0198 333.25 19.0198C328.79 19.0198 326.49 21.9598 326.49 27.2998C326.49 32.6398 328.7 35.5798 332.79 35.5798Z"
        fill="white"
      />
      <path
        d="M362.28 8.56982V34.8398H375.99V38.7998H358.14V8.56982H362.28Z"
        fill="white"
      />
      <path
        d="M394.39 34.6598C392.92 37.6998 390.16 39.2598 386.61 39.2598C380.49 39.2598 377.41 34.0598 377.41 27.2998C377.41 20.5398 380.63 15.3398 387.07 15.3398C390.43 15.3398 393 16.8598 394.38 19.8498V15.7998H398.34V38.7998H394.38V34.6598H394.39ZM387.67 35.5798C391.21 35.5798 394.39 33.3298 394.39 28.2198V26.3798C394.39 21.2698 391.49 19.0198 388.13 19.0198C383.67 19.0198 381.37 21.9598 381.37 27.2998C381.37 32.6398 383.58 35.5798 387.67 35.5798Z"
        fill="white"
      />
      <path
        d="M404.32 38.7997V6.17969H408.28V26.5597L418.17 15.7897H423.32L412.51 27.1097L423.78 38.7997H418.4L408.28 28.0297V38.7997H404.32Z"
        fill="white"
      />
      <path
        d="M436.89 39.2596C428.29 39.2596 424.51 34.2896 424.51 27.2496C424.51 20.2096 428.37 15.3296 435.37 15.3296C442.37 15.3296 445.31 20.2496 445.31 27.2496V29.0396H428.52C429.07 32.9496 431.6 35.4796 437.03 35.4796C439.7 35.4796 441.95 34.9696 444.02 34.2396V37.8696C442.13 38.8796 439.24 39.2496 436.89 39.2496V39.2596ZM428.47 25.6396H441.31C441.08 21.3596 439.15 18.9196 435.19 18.9196C431 18.9196 428.89 21.6296 428.47 25.6396Z"
        fill="white"
      />
      <path
        d="M490.8 40.6001C488.48 40.6001 486.22 39.5501 484.43 37.6401C483.02 36.1301 481.9 35.9301 481 35.9301C480.1 35.9301 478.98 36.1301 477.57 37.6401C475.73 39.6001 473.38 40.6701 471.03 40.6001C468.78 40.5501 466.65 39.4801 465.04 37.6001C464.09 36.4901 463.43 36.3701 463.01 36.3701H461.51V32.7701H463.01C464.76 32.7701 466.36 33.6101 467.78 35.2601C468.73 36.3701 469.88 36.9701 471.12 37.0001C471.15 37.0001 471.18 37.0001 471.21 37.0001C472.53 37.0001 473.85 36.3601 474.96 35.1801C476.75 33.2601 478.74 32.3301 481.02 32.3301C483.3 32.3301 485.29 33.2601 487.08 35.1801C488.21 36.3801 489.5 37.0601 490.92 37.0001C492.15 36.9701 493.3 36.3701 494.25 35.2601C495.67 33.6101 497.27 32.7701 499.02 32.7701H500.52V36.3701H499.02C498.6 36.3701 497.93 36.5001 496.99 37.6001C495.38 39.4801 493.25 40.5501 491 40.6001C490.94 40.6001 490.88 40.6001 490.83 40.6001H490.8Z"
        fill="white"
      />
      <path
        d="M491.64 31.87H489.84V13.29H493.44V27.05C493.44 27.05 493.53 26.96 493.58 26.92C494.88 25.71 496.5 24.2 499 24.2H500.5V27.8H499C497.99 27.8 497.2 28.46 496.03 29.55C494.87 30.63 493.55 31.86 491.64 31.86V31.87Z"
        fill="url(#paint0_linear_2189_2933)"
      />
      <path
        d="M470.36 31.87H472.16V13.29H468.56V27.05C468.51 27.01 468.47 26.96 468.42 26.92C467.12 25.71 465.5 24.2 463 24.2H461.5V27.8H463C464.01 27.8 464.8 28.46 465.97 29.55C467.13 30.63 468.45 31.86 470.36 31.86V31.87Z"
        fill="url(#paint1_linear_2189_2933)"
      />
      <path
        d="M481 19.1799C475.01 19.1799 468.56 17.3399 468.56 13.2899C468.56 9.2399 475.01 7.3999 481 7.3999C486.99 7.3999 493.44 9.2399 493.44 13.2899C493.44 17.3399 486.99 19.1799 481 19.1799ZM481 10.9999C475.42 10.9999 472.37 12.6899 472.16 13.3299C472.37 13.8899 475.42 15.5799 481 15.5799C486.58 15.5799 489.63 13.8899 489.84 13.2499C489.63 12.6899 486.58 10.9999 481 10.9999Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2189_2933"
        x1="494.93"
        y1="27.04"
        x2="491.62"
        y2="13.14"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.1" stopColor="white" stopOpacity="0.4" />
        <stop offset="0.11" stopColor="white" stopOpacity="0.42" />
        <stop offset="0.24" stopColor="white" stopOpacity="0.59" />
        <stop offset="0.38" stopColor="white" stopOpacity="0.74" />
        <stop offset="0.52" stopColor="white" stopOpacity="0.85" />
        <stop offset="0.66" stopColor="white" stopOpacity="0.93" />
        <stop offset="0.79" stopColor="white" stopOpacity="0.98" />
        <stop offset="0.92" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2189_2933"
        x1="467.07"
        y1="27.04"
        x2="470.38"
        y2="13.14"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.1" stopColor="white" stopOpacity="0.4" />
        <stop offset="0.11" stopColor="white" stopOpacity="0.42" />
        <stop offset="0.24" stopColor="white" stopOpacity="0.59" />
        <stop offset="0.38" stopColor="white" stopOpacity="0.74" />
        <stop offset="0.52" stopColor="white" stopOpacity="0.85" />
        <stop offset="0.66" stopColor="white" stopOpacity="0.93" />
        <stop offset="0.79" stopColor="white" stopOpacity="0.98" />
        <stop offset="0.92" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_2189_2933">
        <rect width="501" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
